import { LoggedInGuard } from 'src/core/guards/logged-in.guard';
import { CustomLayoutComponent } from 'src/app/shared/modules/custom-layout/custom-layout.component';
import { AuthGuard } from 'src/core/guards/auth.guard';
import { RedirectGuard } from 'src/core/guards/redirect.guard';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { DashboardAnalyticsComponent } from 'src/app/shared/modules/dashboards/dashboard-analytics/dashboard-analytics.component';
import { LayoutComponent } from 'src/app/layouts/layout/layout.component';
import { LoginComponent } from 'src/app/shared/modules/auth/login/login.component';
import { MainDashboardComponent } from 'src/app/shared/modules/dashboards/main-dashboard/main-dashboard.component';

export const appRoutes: VexRoutes = [

  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: "register",
    loadChildren: () =>
      import(
        "../../../../src/app/shared/modules/auth/register/register.module"
      ).then((m) => m.RegisterModule),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import(
        "../../../../src/app/shared/modules/auth/forgot-password/forgot-password.module"
      ).then((m) => m.ForgotPasswordModule),
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import(
        "../../../../src/app/shared/modules/auth/reset-password/reset-password.module"
      ).then((m) => m.ResetPasswordModule),
  },
  {
    path: "coming-soon",
    loadChildren: () =>
      import(
        "../../../../src/app/shared/modules/coming-soon/coming-soon.module"
      ).then((m) => m.ComingSoonModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate:[AuthGuard],
    children: [
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
       },
       {
          path: '', 
         // component: DashboardAnalyticsComponent, // Use standalone component here
          component: MainDashboardComponent, // Use standalone component here
          canActivate: [AuthGuard, RedirectGuard], // Guards applied here
        
      },
      {
        path: 'profile',
        loadChildren: () => import('../../../../src/app/shared/modules/social/social.routes'),
        canActivate: [AuthGuard]
      },

       { 
        path: "dashboards/analytics",
        redirectTo: "/",
        pathMatch: "full",
      },

      {
        path: 'master-data',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../../../projects/main-portal/src/app/modules/master-data/master-data.module').then(m => m.MasterDataModule),        
      },
      {
        path: 'transactions',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../../../projects/main-portal/src/app/modules/transactions/transactions.module').then(m => m.TransactionsModule),
      },
      {
        path: 'driver-trips',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadChildren: () => import('../../../../projects/main-portal/src/app/modules/role-specific/driver/driver-trips/driver-trips.module').then(m => m.DriverTripsModule),
          }
        ]
      },

      {
        path: 'GPS-Tracking',
        //canActivate: [AuthGuard],
        children: [
          {
            path: '',
            loadChildren: () => import('../../../../projects/main-portal/src/app/modules/Tracking/track-vehicle/track-vehicle.module').then(m => m.TrackVehicleModule),
          }
        ]
      },

      {
        path: 'user-management',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'users',
            loadChildren: () => import("../../../../projects/main-portal/src/app/modules/user-management/user-management.module"

            ).then(m => m.UserManagementModule),
          }
        ],
      },
      {
        path: 'role-management',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'roles',
            loadChildren: () => import("../../../../projects/main-portal/src/app/modules/role-management/role-management.module"

            ).then(m => m.RoleManagementModule),
          }
        ],
      },
      {
        path: '**',
        loadChildren: () => import('../../../../src/app/shared/modules/errors/error-404/error-404.module').then(m => m.Error404Module)
      }
      
    ]
  },
];